import Badge from './Badge';
export type { BadgeProps } from './Badge';
export default Badge;
